import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { unit, UnitManipulationViewModel } from "./unitManipulation-viewModel"

export class UnitManipulationView extends View<UnitManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-5FF4D28D-9E3B-4F36-AB23-68C03E9D9CFF"
    }
    loadHtml(): string {
        let element = require('./unitManipulation.html').default;
        let style = require('./unitManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set units(v: ObservableArray<unit>) { this._units = v; } public get units(): ObservableArray<unit> { return this._units;} private _units: ObservableArray<unit>;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    
    requestUnitCreation(){
        this.dataContext.requestUnitCreation();
    }
}
